<div class="flex items-center justify-between gap-2 mb-2 pr-6">
  <div class="flex items-center gap-2">
    @if (title(); as title) {
      <span class="font-semibold">{{ title }}</span>
    }
    @if (estimated() && !statusAtEnd()) {
      <mat-icon
        class="cursor-help text-ui-gray-125"
        [attr.aria-label]="estimatedTooltip"
        [matTooltip]="estimatedTooltip"
        fontSet="material-icons-outlined"
        >info</mat-icon
      >
    }
  </div>
  @if (trackedWith(); as device) {
    <span class="text-xs text-ui-gray-dark">Tracked with {{ device }}</span>
  } @else if (estimated() && statusAtEnd()) {
    <mat-icon
      class="cursor-help text-ui-gray-125"
      [attr.aria-label]="estimatedTooltip"
      [matTooltip]="estimatedTooltip"
      fontSet="material-icons-outlined"
      >info</mat-icon
    >
  }
</div>

<highcharts-chart
  class="block"
  [options]="chartOptions()"
/>
